export const socials = [{
    name: 'Discord',
    link: 'https://discord.gg/YUtrwyN2jD',
    icon: 'fa-discord'
},
{
    name: 'Twitter',
    link: 'https://twitter.com/DinosolsNFT',
    icon: 'fa-twitter'
}
];

//TODO: move images locally
export const dinoTypes = [{
    name: 'Raptor',
    imageSrc: './images/raptor.gif'
},
{
    name: 'T. rex',
    imageSrc: './images/trex.gif'
},
{
    name: 'Pterodactyl',
    imageSrc: './images/ptero.gif'
},
{
    name: 'Triceratops',
    imageSrc: './images/trice.gif'
}
];

export const teamMembers = [{
    name: 'Poshasaurus Flex',
    title: 'Project Lead',
    image: './images/Posher.png',
    blurb: 'Posher has over 5 years experience researching and investing in blockchain technologies, cryptocurrencies, and NFTs. As a (relatively) early adopter in the Solana NFT ecosystem, his first Solana NFT was a pair of low top CryptoKickers. Outside of the blockchain space, he has held various roles within the private equity and finance industry. He currently holds the role of strategy and investment co-lead in the MonkeDAO.'
},
{
    name: 'Trey-ceratops',
    title: 'Product Manager',
    twitter: 'TreyDinsolsNFT',
    image: './images/Trey.png',
    blurb: 'Trey has vast experience in the start-up world, wearing many hats in many roles. He started as a backend developer and eventually transitioned to a technical product management role where he has led multiple distributed teams. During this time, he has shipped numerous products from scratch that delivered tremendous value to users.'
},
{
    name: 'Blockiosaurus',
    title: 'Lead Developer',
    twitter: 'Blockiosaurus',
    image: './images/Branchio.png',
    blurb: 'Blockiosaurus is a software developer by trade and amateur paleontologist by hobby. He\'s been programming for approximately 20 years, but has loved dinosaurs all his life. In all that time he\'s touched pretty much every aspect of software development and is excited to revive the first generation of Dinosols for the rapidly growing Dinosol Kingdom.'
},
{
    name: 'Dewsaurrrus',
    title: 'Artist',
    twitter: 'dewsaster',
    image: './images/Dew.png',
    blurb: 'Dew has been an artist for over 5 years. He started off his craft focused on non-digital drawing with pointillism and has continued to evolve his talents by moving to digital. He has been in the crypto world since 2019 and has been furiously keeping up on NFTs.'
}
];

export const faq = [
    {
        title: 'What are Dinosols?',
        content: 'Dinosols are a Solana native NFT company that offers a combination of generative dinosaur-themed art, arena battle gameplay, and performance-based leaderboard standings.'
    },

    {
        title: 'What is your cool tagline?',
        contet: 'The fiercest NFT gaming experience on the Solana blockchain in 66 million years.'
    },

    {
        title: 'When launch?',
        content: 'December 4th @ 11PM UTC.'
    },

    {
        title: 'How many Dinosols will there be?',
        content: '4,000. Including 1,000 Dinos of 4 unique species (Raptor, T. rex, Ptero, and Trice). </br> </br> 3,850 will be available for the public sale. 50 are reserved for Dinosol Egg holders and 100 are reserved for marketing purposes.'
    },

    {
        title: 'How much?',
        content: '0.33 SOL'
    },

    {
        title: 'What is the game?',
        content: 'Completely on-chain turn-based arena battle gameplay.  The gameplay is early access and should be viewed as our minimum viable product (MVP) as further improvements and enhancements are expected. The metadata embedded in your Dinosol informs the fighting abilities (e.g. attack, defense, agility, etc). Initially, your Dinosol will be able to fight against a CPU but we expect to quickly enable battle gameplay against other Dinosol holders. In addition, we plan on hosting user versus user tournaments with prizes and awards.'
    },

    {
        title: 'Open-source?',
        content: 'We are open sourcing various aspects of our development, including the gameplay, for the greater benefit of the community. Check out our github page at https://github.com/dinosols'
    },

    {
        title: 'What does the team believe in?',
        content: 'Community and transparency. Our goal is to build a fun and valuable project for our community. We have a long-term view and intent on continuously working to improve and develop the ecosystem.'
    },

    {
        title: 'Eggs?',
        content: 'We minted an exclusive collection of 50 Dinosol Eggs through the Fair Launch Protocol and Candy Machine (“FLP+CM”) at the end of September. The mint was the first 3rd party use of FLP+CM.'
    },

    {
        title: 'What do the Eggs do?',
        content: 'Holders of the Dinosol Egg NFTs will be airdropped a Dinosol with a unique attribute near the Dinosol mint (“hatching”), eligible for other airdrops and prizes, and provided early access to the Dinosol Kingdom game.'
    },

    {
        title: 'How do I get an Egg?',
        content: 'The Eggs are listed on Digital Eyes only: <a href="https://digitaleyes.market/collections/Dinosols">https://digitaleyes.market/collections/Dinosols</a>'
    },

];

export const about = [{
    title: 'Dinosol Holder Value Proposition',
    content: 'Holders of a Dinosols will have: (1) participated in the forefront of Solana NFT-based gameplay; (2) been exclusive holders of Generation 1 Dinosols, which will always hold exclusive in-game benefits, and (3) eligible to receive SOL rewards and prizes for participating in gameplay seasons and tournaments.'
},
{
    title: 'Marketing and Community',
    content: 'We will only engage in honest and transparent marketing efforts, which will include giveaways and promotions to increase awareness of our project. Our ultimate goal is to build a strong community that will exemplify respect, acceptance, and integrity.'
},
{
    title: 'Open Source Development',
    content: 'Two of our founding principles are transparency and community. With those principles in mind, we have elected to develop an open source gaming standard for us and other NFT projects to use. This standard will supply post-mint functionality for the NFT community as a whole. In addition, we will be providing other ad hoc tools we used during development including, but not limited to, our generative art program.'
},
];

export const arcadeGames = [{
    name: 'Flappy Ptero',
    link: './flappyptero',
    image: './images/flappyptero.png',
    blurb: 'Our take on Flappy Bird. Control the Pterodactyl and dodge the pipes!'
},
{
    name: 'Egg Breakout',
    link: './eggout',
    image: './images/eggout.png',
    blurb: 'Breakout, but with eggs! Collect all the SOL to win.'
},
{
    name: 'T. rex Runner',
    link: './rexjump',
    image: './images/rexrun.png',
    blurb: 'Control the T. rex and jump over Soltreez and Pterodactyls.'
},
{
    name: 'Asteroids',
    link: './asteroid_js/asteroids/',
    image: './images/asteroids.png',
    blurb: 'The Solanauts have come to the aid of the Dinosols, helping them reach space to take revenge on their asteroid enemies.'
},
{
    name: 'Raptor Man',
    link: './pacrap',
    image: './images/pacrap.jpeg',
    blurb: 'Our spin on PAC-MAN in partnership with Hollow Soldiers. Avoid the Roamers and collect the eggs to power up!'
},
{
    name: 'Stampede',
    link: './Stampede',
    image: './images/stampede.png',
    blurb: 'In partnership with Jungle Cats, save the Dinosol eggs from the Triceratops stampede!'
},
];